import { useState, useEffect } from 'react';

function useWindowDimensions() {
    const getWindowDimensions = () => {
        if (typeof window === 'undefined') {
            return { width: 0, height: 0 };
        }
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };

    const [windowDimensions, setWindowDimensions] = useState<{ width: number; height: number }>(
        getWindowDimensions()
    );

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions(getWindowDimensions());
        };
        setWindowDimensions(getWindowDimensions());
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

export default useWindowDimensions;
